import {JsonProperty} from 'json-typescript-mapper';
import {Marketday} from './marketday.model';
import {Contact} from './contact.model';
import {Marketdate} from './marketdate.model';
import { Log, logError, SmsLogHttpResponseBody } from './log.model';

export class OpenPaymentInfo {
  @JsonProperty('id')
  public id?: number;

  @JsonProperty('marketday')
  public marketday?: number;

  @JsonProperty('merchant')
  public merchant?: number;

  @JsonProperty('marketdate')
  public marketdate?: number;

  @JsonProperty('amount')
  public amount?: number;

  @JsonProperty('date')
  public date?: string;

  @JsonProperty('status')
  public status?: string;

  @JsonProperty('updatedBy')
  public updatedBy?: number;

  @JsonProperty('comment')
  public comment?: string;

  @JsonProperty('branchComment')
  public branchComment?: string;

  @JsonProperty('keyword')
  public keyword?: string;

  @JsonProperty('evasiveDate')
  public evasiveDate?: string;

  @JsonProperty('merchantNumber')
  public merchantNumber?: string;

  @JsonProperty('company')
  public company?: string;

  @JsonProperty('companyAdditional')
  public companyAdditional?: string;

  @JsonProperty('branchString')
  public branchString?: string;

  constructor() {
    this.id = void 0;
    this.marketday = void 0;
    this.merchant = void 0;
    this.marketdate = void 0;
    this.amount = void 0;
    this.date = void 0;
    this.status = void 0;
    this.updatedBy = void 0;
    this.comment = void 0;
    this.branchComment = void 0;
    this.keyword = void 0;
    this.evasiveDate = void 0;
    this.merchantNumber = void 0;
    this.company = void 0;
    this.companyAdditional = void 0;
    this.branchString = void 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/open-payment-info.model.ts